module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gerald Asamoah Stiftung","short_name":"Gerald Asamoah Stiftung","display":"standalone","start_url":"/","background_color":"#ffffff","theme_color":"#A59361","icon":"src/images/asamoah-stiftung-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"72ee53b3507b966eca29b95bc4cdac4e"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
